import { useMemo } from 'react'

import { clsx } from 'clsx'

import {
  PhysicalLocation,
  VirtualLocation,
} from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useI18n } from '../../../../i18n/index.js'

interface Props {
  physicalLocations: PhysicalLocation[]
  virtualLocations: VirtualLocation[]
  className?: string
  iconClassName?: string
}

export const EventLocation = ({
  physicalLocations,
  className,
  iconClassName,
  virtualLocations,
}: Props) => {
  const { $t } = useI18n()
  const text = useMemo(() => {
    if (physicalLocations.length > 0) {
      return physicalLocations.map(location => location.displayName).join(', ')
    }
    if (virtualLocations && virtualLocations.length > 0) {
      return $t({ defaultMessage: 'Virtual', id: 'Generics.Virtual' })
    }
    return null
  }, [$t, physicalLocations, virtualLocations])

  if (!text) {
    return null
  }
  return (
    <div className={clsx('flex items-center text-sm min-w-0', className)}>
      <SvgIcon className={clsx('mr-1', iconClassName)} name="location-marker" />
      <span className="truncate">{text}</span>
    </div>
  )
}
